import Vue from 'vue'
import Router from 'vue-router'
 
//组件模块
import Home from '@/components/Home.vue'
import About from '@/components/About.vue'
import Social from '@/components/Social.vue'
import Insight from '@/components/Insight.vue'
import Wechat from '@/components/Wechat.vue'
import Marketing from '@/components/Marketing.vue'
import Itdd from '@/components/Itdd.vue'
import Ptraffic from '@/components/Ptraffic.vue'
import Product from '@/components/Product.vue'
import Innovation from '@/components/Innovation.vue'
import Sesameeats from '@/components/Sesameeats.vue'
import Wildlife from '@/components/Wildlife.vue'
import Huazhu from '@/components/Huazhu.vue'
import Consumer from '@/components/Consumer.vue'
import Sports from '@/components/Sports.vue'
import Retail from '@/components/Retail.vue'
import Tmall from '@/components/Tmall.vue'
import People from '@/components/People.vue'
import Article_1 from '@/components/Article_1.vue'
import Article_2 from '@/components/Article_2.vue'
import Article_3 from '@/components/Article_3.vue'
import Article_4 from '@/components/Article_4.vue'
import Article_5 from '@/components/Article_5.vue'
import Article_6 from '@/components/Article_6.vue'
 
Vue.use(Router)
 
export default new Router({
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        { path: '/', name: 'Home', component: Home },
        { path: '/about-overview', name: 'About', component: About },
        { path: '/about-social-resposibility', name: 'Social', component: Social },
        { path: '/insight', name: 'Insight', component: Insight },
        { path: '/ability-wechat', name: 'Wechat', component: Wechat },
        { path: '/service-digital-marketing', name: 'Marketing', component: Marketing },
        { path: '/service-itdd', name: 'Itdd', component: Itdd },
        { path: '/service-private-traffic', name: 'Ptraffic ', component: Ptraffic},
        { path: '/product', name: 'Product', component: Product },
        { path: '/ability-innovation', name: 'Innovation', component:Innovation },
        { path: '/case-sesameeats', name: 'Sesameeats', component: Sesameeats },
        { path: '/case-wildlife', name: 'Wildlife', component: Wildlife },
        { path: '/industry-hotel', name: 'Huazhu', component: Huazhu },
        { path: '/industry-consumergoods', name: 'Consumer', component: Consumer },
        { path: '/industry-retail', name: 'Retail', component: Retail },
        { path: '/industry-sportswear', name: 'Sports', component: Sports },
        { path: '/case-tmall', name: 'Tmall', component: Tmall },
        { path: '/about-team', name: 'People', component: People },
        { path: '/article1', name: 'Article_1', component: Article_1 },
        { path: '/article2', name: 'Article_2', component: Article_2 },
        { path: '/article3', name: 'Article_3', component: Article_3 },
        { path: '/article4', name: 'Article_4', component: Article_4 },
        { path: '/article5', name: 'Article_5', component: Article_5 },
        { path: '/article6', name: 'Article_6', component: Article_6 }
    ]
})